// API do betracking: o rastreio (/api/track) e a entrega ao vivo
// (/api/live-deliveries/share/:token, o mapa).
export const API_URL =
  import.meta.env.MODE === 'development'
    ? 'http://localhost:1337'
    : 'https://api.betracking.beuni.com.br';
